import { useTranslation } from "../i18n";
import PosAdmin from "../components/PosAdmin";
import AdminPageHeader from "../components/admin-page-header";
import "../styles/admin-settings.css";

// Admin → Warehouse → POs. Manifest lines grouped by supplier and PO
// number, with expected-vs-received match-up and PO-level status actions.
const AdminPos = () => {
    const { t } = useTranslation();
    return (
        <div className="page-data page-data-wide" style={{ height: "calc(100vh - 56px)", overflow: "auto" }}>
            <AdminPageHeader
                titleKey="pos_settings"
                backTo="/admin/warehouse"
                hideSearch
                crumbs={[
                    { labelKey: "admin_panel", to: "/admin" },
                    { labelKey: "warehouse_menu_title", to: "/admin/warehouse" },
                    { labelKey: "pos_settings" },
                ]}
            />
            <div className="admin-settings-section">
                <p className="admin-settings-section-hint">{t("pos_settings_hint")}</p>
                <PosAdmin />
            </div>
        </div>
    );
};

export default AdminPos;
